export type MarkNotificationAsReadParams = {
  notificationId: number
}

const endpoints = {
  getNotifications: `api/v2/users/user-id/notifications/`,
  markNotificationAsRead: ({ notificationId }: MarkNotificationAsReadParams): string => {
    return `api/v2/users/user-id/notifications/${notificationId}/`
  },
}

export default endpoints
